// 弹窗出现时锁定滚动，弹窗关闭时解锁滚动
import { watch, type Ref } from 'vue'
import { lockAppScroll, unlockAppScroll } from '@/utils/scroll-lock-manager'

export function useLockAppScrollWhenVisible(visible: Ref<boolean>) {
  const { isMobile } = useDevice()
  watch(
    visible,
    val => {
      if (val && isMobile) {
        lockAppScroll()
        setTimeout(() => {
          unlockAppScroll()
        }, 30000)
      } else {
        unlockAppScroll()
      }
    },
    { immediate: false },
  )
}
